// @flow

import * as React from 'react';
import ReactAI from 'react-appinsights';

type Props = {
    phaseNr: number,
    totalPhaseCount: number,
    error: {[name:string]: ?string},
};

const CalculationErrorList = (props: Props) => {
    let loc = window.location.toString();
    if(window.location.hash)
        loc = loc.replace(window.location.hash, "");
    
    let phaseString = '';
    if(props.totalPhaseCount > 1 && props.phaseNr > 0)
        phaseString = `Etapp ${props.phaseNr}: `;
    
    return <div className="calculation-error-list">
        {Object.keys(props.error).filter(key => typeof props.error[key] === 'string').map(errorKey => <a key={errorKey} href={`${loc}#${errorKey + 'Lbl' + (props.phaseNr > 0 ? '-phase' + props.phaseNr : '')}`} style={{textDecoration: "none"}}>
            <div className="alert alert-warning" role="alert">
                <span>{phaseString}{props.error[errorKey]}</span>
            </div>
        </a>) }
    </div>


};

export default ReactAI.withTracking(CalculationErrorList);




// WEBPACK FOOTER //
// ./src/components/CalculationErrorList.js